export const radius = {
  r1: '1px',
  r2: '10px',
  r3: '24px',
  r3_mobile: '16px',
  rMax: '9999px',
  rBoxes: '20px',
}
